/* tutor-2 (B, C): LAS PREGUNTAS DE PANTALLA DEL TUTOR, en un solo sitio.

   ARCHIVO EN ASCII A PROPOSITO.

   - `useEsTelefono()`: abajo de 768 (`md`), la pagina va en su diseno de telefono (hojas desde abajo, sin el aviso
     del cuadro). Sin `matchMedia` (jsdom) contesta que no: la computadora, el diseno de siempre.
   - `useTarjetaALaDerecha()`: desde 1,180 la tarjeta de a media sesion flota a la derecha; abajo, es hoja.
   - `useAltoConTeclado(ref, abierto)`: con el teclado abierto, el alto que deja el `visualViewport` debajo del borde
     de arriba del elemento (los mismos `height` y `offsetTop` que lee `useKeyboardOpen`), para que el cuadro quede
     pegado al teclado; cerrado, `null` (el alto de siempre). */
import { useLayoutEffect, useState } from 'react';
import { useMedia } from '../../lib/useEsAncho';

export const CONSULTA_TELEFONO = '(max-width: 767px)';
export const CONSULTA_TARJETA_A_LA_DERECHA = '(min-width: 1180px)';
export const AIRE_SOBRE_EL_TECLADO_PX = 8;

export function useEsTelefono() {
  return useMedia(CONSULTA_TELEFONO, false);
}

export function useTarjetaALaDerecha() {
  return useMedia(CONSULTA_TARJETA_A_LA_DERECHA, true);
}

export function altoVisibleDebajoDe(el, vv, aire = AIRE_SOBRE_EL_TECLADO_PX) {
  if (!el || !vv) return null;
  const arriba = el.getBoundingClientRect().top;
  return Math.max(120, Math.round((vv.offsetTop || 0) + vv.height - arriba - aire));
}

export function useAltoConTeclado(ref, abierto) {
  const [alto, setAlto] = useState(null);
  useLayoutEffect(() => {
    const vv = typeof window !== 'undefined' ? window.visualViewport : null;
    if (!abierto || !vv) {
      setAlto(null);
      return undefined;
    }
    const medir = () => setAlto(altoVisibleDebajoDe(ref.current, vv));
    medir();
    vv.addEventListener('resize', medir);
    vv.addEventListener('scroll', medir);
    return () => {
      vv.removeEventListener('resize', medir);
      vv.removeEventListener('scroll', medir);
    };
  }, [abierto, ref]);
  return alto;
}
